import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function AjouterEmploye() {
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [poste, setPoste] = useState('');
  const [email, setEmail] = useState('');
  const [dateEmbauche, setDateEmbauche] = useState('');
  const [employes, setEmployes] = useState([]);
  const [message, setMessage] = useState('');
  const API_URL = `${process.env.REACT_APP_API_URL}/collaborateurs`; // Déclarée ici

  useEffect(() => {
    const fetchEmployes = async () => {
      try {
        const response = await axios.get(API_URL);
        setEmployes(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des employés :', error);
      }
    };
    fetchEmployes();
  }, [API_URL]); // ← Ajoute API_URL ici

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!nom.trim() || !prenom.trim() || !poste.trim() || !email.trim() || !dateEmbauche.trim()) {
      setMessage('Tous les champs sont obligatoires.');
      return;
    }
    try {
      await axios.post(API_URL, {
        nom,
        prenom,
        poste,
        email,
        date_embauche: dateEmbauche,
        statut: 'actif',
      });
      // Rafraîchir la liste des employés
      const updatedResponse = await axios.get(API_URL);
      setEmployes(updatedResponse.data);
      setMessage('Employé ajouté avec succès !');
      setNom('');
      setPrenom('');
      setPoste('');
      setEmail('');
      setDateEmbauche('');
    } catch (error) {
      console.error('Erreur lors de l\'ajout de l\'employé :', error);
      setMessage('Erreur lors de l\'ajout de l\'employé.');
    }
  };

  return (
    <div>
      <h1>Ajouter un Employé</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Nom: </label>
          <input type="text" value={nom} onChange={(e) => setNom(e.target.value)} required />
        </div>
        <div>
          <label>Prénom: </label>
          <input type="text" value={prenom} onChange={(e) => setPrenom(e.target.value)} required />
        </div>
        <div>
          <label>Poste: </label>
          <input type="text" value={poste} onChange={(e) => setPoste(e.target.value)} required />
        </div>
        <div>
          <label>Email: </label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label>Date d'embauche: </label>
          <input type="date" value={dateEmbauche} onChange={(e) => setDateEmbauche(e.target.value)} required />
        </div>
        <button type="submit">Ajouter</button>
      {message && <p>{message}</p>}
      </form>
      <h2>Liste des employés</h2>
      {employes.length === 0 ? (
        <p>Aucun employé enregistré.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Nom</th>
              <th>Prénom</th>
              <th>Poste</th>
              <th>Email</th>
              <th>Date d'embauche</th>
            </tr>
          </thead>
          <tbody>
            {employes.map((employe) => (
              <tr key={employe.id}>
                <td>
                  <Link to={`/collaborateurs/${employe.id}`}>{employe.nom}</Link>
                </td>
                <td>{employe.prenom}</td>
                <td>{employe.poste}</td>
                <td>{employe.email}</td>
                <td>{new Date(employe.date_embauche).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AjouterEmploye;
